import { Field, ErrorMessage } from 'formik'
import React from 'react'

import FormFieldErrorMessage from './form-field-error-message'
import PopperTooltip from '../popper-tooltip/PopperTooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

const InputFormikField: React.FC<any> = ({
  touched = {},
  errors = {},
  label = '',
  placeholder = '',
  newLineForHelpText = true,
  name = '',
  helpText = '',
  type = 'text',
  min = '',
  max = '',
  step = '',
  disabled = false,
  required = false,
  maxlength = '',
  toolTipMessage = '',
  toolTipTitle = '',
  readOnly = false,
}) => (
  <>
    <label
      className={`${
        readOnly && 'border-bottom'
      } flex flex-col justify-between py-3 sm:items-start label`}
    >
      {label ? (
        <span className={`${readOnly ? 'text-black' : 'font-bold'} text-base`}>
          {label} {required ? <span className="text-warn-600">*</span> : ''}{' '}
          {toolTipMessage ? (
            <PopperTooltip message={toolTipMessage} title={toolTipTitle || ''}>
              <FontAwesomeIcon icon={faInfoCircle} />
            </PopperTooltip>
          ) : null}
          {newLineForHelpText ? <br /> : null}{' '}
          {helpText ? <span className="font-normal text-xs">{helpText}</span> : null}
        </span>
      ) : null}
      <div className="w-full">
        <div className="flex justify-between items-center">
          <Field
            type={type}
            name={name}
            placeholder={placeholder}
            className={`${
              errors[name] && touched[name] ? 'input-danger' : 'input'
            } w-11/12 form-input p-2 rounded mt-1 placeholder-grey-700 mr-2 input`}
            min={min}
            max={max}
            step={step}
            disabled={disabled}
            maxLength={maxlength}
            readOnly={readOnly}
          />
        </div>
      </div>
      <div className="min-h-6">
        <ErrorMessage component={FormFieldErrorMessage} name={name} />
      </div>
    </label>
  </>
)

export default InputFormikField
